import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ViewMode } from '../types';

@customElement('loading-files')
export class LoadingFiles extends LitElement {
  static readonly styles = css`

      .placeholders {
        position: relative;
          max-height: 768px;
          overflow: hidden;
          mask-image: linear-gradient(to bottom, black, transparent);
        }

        .placeholders .info {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 32px;
          text-align: center;
        }

        .placeholder {
          height: 200px;
          background-color: #cacaca;
          border: 1px solid #cacaca
          cursor: not-allowed;
          opacity: 0.75;
          border-radius: 12px;
          animation: placeholder 1s infinite;
          transition: all 0.2s ease-in-out;
        }


    @keyframes placeholder {
      0% {
        background-color: #cacaca;
      }
      50% {
        background-color: color-mix(in srgb, #cacaca 80%, #fff);
      }
      100% {
        background-color: #cacaca;
      }
    }
`;

  @property({ type: String })
  viewMode: ViewMode = ViewMode.card;

  render() {
    if (this.viewMode === ViewMode.card) {
      return html`<div class="gallery-cards placeholders">
        ${Array.from({ length: 10 }).map(
          () => html`<div class="placeholder gallery-cards__item"></div>`
        )}
        <div class="info">Loading gallery files...</div>
      </div>`;
    }

    if (this.viewMode === ViewMode.list) {
      return html` <p>Loading...</p> `;
    }

    return html` <p>Loading...</p> `;
  }
}
